import { Radio, RadioCard, RadioGroup } from "@/components/frontend/ui/form/inputs/radio";
import Description from "@/components/frontend/ui/form/inputs/description";
import FieldError from "@/components/frontend/ui/form/inputs/field-error";
import { cn } from "@/lib/utils";
import { type FormRadioBlock as FormRadioBlockT } from "@/payload-types";

type FormRadioBlockProps = FormRadioBlockT & {
	containerClassName?: string;
	fieldName?: string;
	fieldValue?: unknown;
	fieldError?: string;
	onFieldChange?: (value: unknown) => void;
	onFieldBlur?: () => void;
};

const cardGridMap = {
	1: null,
	2: "sm:grid-cols-2",
	3: "md:grid-cols-3 sm:grid-cols-2",
};

export const FormRadioBlock: React.FC<FormRadioBlockProps> = ({
	content,
	options,
	layout,
	containerClassName,
	fieldName,
	fieldValue,
	fieldError,
	onFieldChange,
	onFieldBlur,
}) => {
	const value = typeof fieldValue === "string" ? fieldValue : (options?.find((option) => option.defaultChecked)?.value ?? "");

	return (
		<div className={cn("flex flex-col items-start gap-1", containerClassName)}>
			<RadioGroup
				name={fieldName}
				label={content?.label ?? undefined}
				required={content?.required ?? false}
				value={value}
				onValueChange={(value) => onFieldChange?.(value)}
				onBlur={onFieldBlur}
				className="w-full"
				aria-required={content?.required ?? false}
				radiosContainerClassName={cn(
					layout?.groupDirection === "horizontal" && "flex-row flex-wrap gap-x-4 gap-y-2",
					layout?.renderCards && "grid gap-2",
					layout?.renderCards && cardGridMap[(layout?.columns ?? 2) as keyof typeof cardGridMap],
				)}
			>
				{options?.map((option) => {
					if (layout?.renderCards) {
						return <RadioCard key={option.value} label={option.label} description={option.description ?? undefined} value={option.value} />;
					} else {
						return <Radio key={option.value} label={option.label} value={option.value} />;
					}
				})}
			</RadioGroup>

			{content?.description && <Description>{content.description}</Description>}

			<FieldError message={fieldError} />
		</div>
	);
};
